
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mechanism-of-action",
      function () {
        return require("private-next-pages/mechanism-of-action.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mechanism-of-action"])
      });
    }
  